import styled from "@emotion/styled";
import { Colors } from "theme/colors";

export const StyledNavigation = styled.div`
  margin-bottom: 2rem;
  padding: 2rem;

  display: flex;
  justify-content: center;

  margin-left: -2rem;
  margin-right: -2rem;
  margin-top: -2rem;

  background-color: ${Colors.WHITE};
  box-shadow: 0 0.59rem 1.175rem 0 rgba(0, 0, 0, 0.2);
`;
